<template>
  <div class="calcu-body buyness-calcu">
    <van-form class="form-bg">
      <!-- 计算方式 -->
      <van-field name="radio" label="计算方式" class="cal-method">
        <template #input>
          <van-radio-group
            v-model="formData.methodType"
            direction="horizontal"
            @change="calcuMethodChange"
          >
            <div class="radioDiv">
              <van-radio
                name="2"
                :class="
                  Number(formData.methodType) === 2 ? 'active' : 'inactive'
                "
              >
                <div class="radio-text">按贷款总额</div></van-radio
              >
              <van-radio
                name="1"
                :class="
                  Number(formData.methodType) === 1 ? 'active' : 'inactive'
                "
              >
                <div class="radio-text">按房屋总价</div>
              </van-radio>
            </div>
          </van-radio-group>
        </template>
      </van-field>

      <!-- 房屋总价 -->
      <van-field
        readonly
        v-model="formData.houseTotal"
        type="number"
        name="房屋总价"
        label="房屋总价"
        autocomplete="off"
        placeholder="请输入房屋总价"
        v-if="formData.calcuMethod === '按房屋总价'"
        @focus="houseTotalFocus"
        @click="houseKeyboardShow = true"
      >
        <template #input>
          <div @click="houseTotalFocus" class="input-container">
            <span>{{ formData.houseTotal }}</span>
            <div
              :style="houseKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix">万</span>
        </template>
      </van-field>
      <!-- 房屋总价的数字键盘 -->
      <van-number-keyboard
        :show="houseKeyboardShow"
        v-model="formData.houseTotal"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="
          () => {
            ((this.blurBool = true), houseKeyboardClose());
          }
        "
        @blur="
          () => {
            ((this.blurBool = false), houseKeyboardClose());
          }
        "
        style="z-index: 3000"
      />

      <!-- 首付比例 -->
      <van-field
        v-model="formData.downPayment"
        name="radio"
        label="首付比例"
        v-if="formData.calcuMethod === '按房屋总价'"
        @click-input="shoufuKeyboardShow = true"
        readonly
      >
        <template #input>
          <div @click="shoufuKeyboardShow = true" class="input-container">
            <span>{{ formData.downPayment }}</span>
            <div
              :style="shoufuKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix"> %</span>
        </template>
      </van-field>
      <van-number-keyboard
        :show="shoufuKeyboardShow"
        v-model="formData.downPayment"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="shoufuKeyboardClose"
        @blur="shoufuKeyboardClose"
        style="z-index: 3000"
      />

      <!-- 公积金金额 -->
      <van-field
        v-model="formData.total"
        type="number"
        name="公积金金额"
        label="公积金金额"
        autocomplete="off"
        placeholder="请输入公积金金额"
        @focus="totalFocus"
        @click-input="totalKeyboardShow = true"
        readonly
      >
        <template #input>
          <div @click="totalFocus" class="input-container">
            <span>{{ formData.total }}</span>
            <div
              :style="totalKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix">万</span>
        </template>
      </van-field>
      <van-number-keyboard
        :show="totalKeyboardShow"
        v-model="formData.total"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="totalKeyboardClose"
      />

      <!-- 贷款年限 -->
      <van-field
        readonly
        clickable
        v-model="formData.loanTerm"
        label="公积金年限"
        placeholder="点击选择公积金年限"
        @focus="showLoanTermPicker = true"
        @click-right-icon="showLoanTermPicker = true"
      >
        <template #right-icon>
          <img
            src="https://static-official.5i5j.com/offical/cdn/f92d18faa3f0d02eec919e78f354c308_1732253601301.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
      </van-field>
      <keep-alive>
        <van-popup v-model="showLoanTermPicker" round position="bottom">
          <van-picker
            title="商贷年限"
            show-toolbar
            :default-index="
              loanTermList.findIndex((item) => formData.loanTerm === item) || 0
            "
            :columns="loanTermList"
            @confirm="onLoanTermComplete"
            @cancel="showLoanTermPicker = false"
        /></van-popup>
      </keep-alive>

      <!-- 贷款利率 -->
      <van-field
        readonly
        clickable
        :value="formData.rate"
        label="公积金利率"
        placeholder="点击选择利率方式"
        @focus="showRatePicker = true"
        @click-right-icon="showRatePicker = true"
        @click-left-icon="handleRateHelp"
        class="left-195"
      >
        <template #right-icon>
          <span v-if="spanShow" class="suffix"> % </span>
          <img
            src="https://static-official.5i5j.com/offical/cdn/f92d18faa3f0d02eec919e78f354c308_1732253601301.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
      </van-field>
      <keep-alive>
        <NewPicker
          title="公积金利率"
          :pickList="rateList"
          typeKey="rate"
          v-if="showRatePicker"
          @pickerHandle="pickerHandle"
          @pickerClose="pickerClose"
          @clickPicker="handleCustomRate"
        >
          <template #footer>
            <div class="picker-footer">
              <span>自定义输入</span>
              <input
                type="text"
                placeholder="可输入公积金利率"
                v-model="formData.customRate"
              />%
              <!-- <button class="customer-btn" @click="handleCustomRate">
                确定
              </button> -->
            </div>
          </template>
        </NewPicker>
      </keep-alive>
      <div style="margin-top: 14px; margin-left: 22px">
        <van-button class="submit-btn" @click="onSubmit">开始计算</van-button>
      </div>
    </van-form>

    <!-- 模态框 -->
    <van-dialog
      v-model="customModalShow"
      show-cancel-button
      confirm-button-color="#FFCC33"
      @confirm="modalConfirm"
      @cancel="modalCancel"
    >
      <template #default>
        <div class="custom-dialog-content">
          目前贷款年限最大{{
            parseInt(loanTermList[loanTermList.length - 1])
          }}年，您确定查看吗？
        </div>
      </template>
    </van-dialog>

    <van-dialog
      v-model="pubaccuModalShow"
      show-cancel-button
      confirm-button-color="#FFCC33"
      @confirm="accModalConfirm"
      @cancel="accModalCancel"
    >
      <template #default>
        <div class="custom-dialog-content">
          目前{{ locationCity }}最高公积金贷款金额为{{
            firstMaxFundLoan
          }}万元，您确定要按照{{ formData.total }}万元的公积金贷款进行计算吗？
        </div>
      </template>
    </van-dialog>
    <!-- 提交提示loading-->
    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import $http from "../../utils/request";
import { CustomDownPaymentNum } from "../../validate/index";
import { mapState } from "vuex";
import NewPicker from "../../components/NewPicker";
import Loading from "../../components/loading";
import { getWebViewEnv } from "../../utils/app-bridge";
export default {
  components: {
    NewPicker,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      showMehodsPicker: false,
      methodsList: [
        { text: "按房屋总价", value: 1 },
        { text: "按贷款总额", value: 2 },
      ],
      showLoanTermPicker: false,
      // loanTermList: ["5年", "10年", "15年", "20年", "25年", "30年"],
      showRatePicker: false,
      spanShow: false,
      showDownPaymentPicker: false,
      formData: {
        total: "0",
        calcuMethod: this.$route.query.cal || "按贷款总额",
        loanTerm: "",
        customTerm: "",
        rate: "",
        customRate: "",
        houseTotal: "0",
        isFirst: "1",
        methodType: "2",
        downPayment: this.$store.state.first_downpayment_percent,
        customDownPayment: "",
      },
      pubaccuModalShow: false,
      customModalShow: false,
      selectedPayment: false,
      totalKeyboardShow: false,
      houseKeyboardShow: false,
      customDownPaymentKeyboardShow: false,
      customTermkeyboardShow: false,
      customRatekeyboardShow: false,
      shoufuKeyboardShow: false,
      blurBool: false,
    };
  },
  watch: {
    loanTermList: {
      handler(newVal) {
        if (newVal) {
          this.formData.loanTerm = newVal[newVal.length - 1];
        }
      },
      immediate: true,
    },
    rateList: {
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.formData.rate = newVal[0].text;
        }
      },
      immediate: true,
    },
    downPayment: {
      handler(newVal) {
        console.log(newVal, "newVal");
        this.formData.downPayment = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    inputReg(e) {
      if (this.formData.customTerm.length == 1 && e.data == 0) {
        this.formData.customTerm = "";
      } else {
        let inputReg = this.formData.customTerm.replace(/[^0-9]/g, "");
        this.formData.customTerm = inputReg;
      }
    },
    pickerClose(typeKey) {
      switch (typeKey) {
        case "downPayment":
          this.showDownPaymentPicker = false;
          break;
        case "loanTerm":
          this.showLoanTermPicker = false;
          break;
        case "rate":
          this.showRatePicker = false;
          break;
      }
    },
    pickerHandle(isShow, selected, typeKey) {
      console.log(isShow, selected, typeKey);
      switch (typeKey) {
        case "downPayment":
          this.onDownPaymentComplete(selected);
          break;
        case "loanTerm":
          this.onLoanTermComplete(selected);
          break;
        case "rate":
          this.onRateComplete(selected);
          break;
      }
    },
    consolefoucs() {
      this.shoufuKeyboardShow = true;
    },
    totalFocus() {
      if (this.formData.total == 0) {
        this.formData.total = "";
      }
      document.activeElement.blur();
    },
    houseTotalFocus() {
      if (this.formData.houseTotal == 0) {
        this.formData.houseTotal = "";
      }
      document.activeElement.blur();
    },
    // 公积金金额的数字键盘关闭
    totalKeyboardClose() {
      this.checkTotal(this.formData.total);
    },
    // 房屋总价数字键盘的关闭事件
    houseKeyboardClose() {
      if (this.formData.houseTotal) {
        this.onHouseTotal(this.formData.houseTotal);
      }
      this.checkTotal(this.formData.total, "house");
      this.houseKeyboardShow = false;
    },
    // 首付比例的数字键盘关闭
    shoufuKeyboardClose() {
      if (this.formData.downPayment) {
        this.onDownPayment(this.formData.downPayment);
      }
      this.shoufuKeyboardShow = false;
    },
    onDownPayment(value) {
      // 首付比例输入监听

      if (Number(value)) {
        const valueStr = String(parseInt(value));
        const dicStr = String(value).split(".")[1];

        if (dicStr) {
          this.$toast("请输入整数");
          this.formData.downPayment = valueStr;
        } else if (Number(valueStr) > 100) {
          this.$toast("输入值过大,请重新输入");
          this.formData.downPayment =
            this.$store.state.first_downpayment_percent;
        } else {
          this.formData.downPayment = value;
        }
        const totalValue =
          (Number(this.formData.houseTotal) *
            (100 - parseInt(this.formData.downPayment))) /
          (100).toFixed(2);
        if (Number(totalValue) > this.firstMaxFundLoan) {
          this.formData.total = this.firstMaxFundLoan;
          this.$toast(`当前公积金上限为${this.firstMaxFundLoan}万,请重新输入`);
        } else {
          this.formData.total = totalValue;
        }
      }
    },
    onSubmit() {
      // 开始计算的埋点

      if (this.formData.calcuMethod === "按贷款总额") {
        if (!Number(this.formData.total)) {
          this.$toast("请输入大于0的数值");
          this.formData.total = "0";
          return;
        }
        if (Number(this.formData.total) > this.firstMaxFundLoan) {
          this.$toast(`当前公积金上限为${this.firstMaxFundLoan}万,请重新输入`);
          this.formData.total = this.firstMaxFundLoan;
          return;
        }
      } else if (this.formData.calcuMethod === "按房屋总价") {
        if (!Number(this.formData.houseTotal)) {
          this.$toast("请输入大于0的数值");
          this.formData.houseTotal = "0";
          return;
        } else if (!Number(this.formData.total)) {
          this.$toast("请输入大于0金额");
          this.formData.total = "0";
          return;
        }
      }
      // TODO 表单提交
      const data = {};
      data.fund_loan_time = parseInt(this.formData.loanTerm);
      data.fund_loan_value = Number(this.formData.total);
      // 需要判断当前是否为自定义利率，逻辑同商业贷款
      const presetRate = this.rateList.find(
        (item) => item.text === this.formData.rate,
      )?.value;
      if (presetRate !== undefined) {
        data.fund_loan_rate = Number(presetRate) / 100;
      } else {
        // 自定义利率：提交前校验，不合法则拦截
        if (!this.isFundRateCustom()) {
          return;
        }
        data.fund_loan_rate = Number(this.formData.customRate) / 100;
      }

      if (this.formData.calcuMethod === "按房屋总价") {
        data.is_first = this.formData.isFirst === "1" ? 1 : 0;
        data.house_price = Number(this.formData.houseTotal);
        // data.payment_percent =
        //   parseFloat(
        //     document.getElementsByClassName("down-payment-per")[0].innerText
        //   ) / 100;
      } else {
        // 为保证参数的完整性，页面上不存在的参数传空字符串（后端要求）
        data.is_first = "";
        data.house_price = "";
        data.payment_percent = "";
      }
      // 为保证参数的完整性，页面上不存在的参数传空字符串（后端要求）
      data.com_loan_time = "";
      data.com_loan_value = "";
      data.com_loan_rate = "";

      // 如果有经纪人信息给经纪人推送
      if (this.peopleInfo.broker_id) {
        const { broker_id, user_id } = this.peopleInfo;
        data.user_id = user_id;
        data.broker_id = broker_id;
        data.result_url = `${
          window.location.origin
        }/calculator/#/CommercialIoanDetailed?type=pubaccu&cal=${
          this.formData.calcuMethod
        }&form=${encodeURIComponent(JSON.stringify(data))}&cityid=${
          this.$store.state.location.cityId
        }&cityname=${this.$store.state.location.cityName}&hideBroker=${
          this.$route.query?.hideBroker
        }`;
      }
      this.isLoading = true;
      data.platform = getWebViewEnv();
      $http({
        url: `/appapi/normals/${this.$store.state.location.cityId}/v1/loandetails`,
        method: "post",
        data,
      })
        .then((res) => {
          if (res.msg == "OK") {
            this.$store.dispatch("setCalcuRes", res.data);
            this.isLoading = false;
            // 在localStorage中做本地持久化
            localStorage.setItem("calcuRes", JSON.stringify(res.data));
            this.$router.push(
              `/CommercialIoanDetailed?type=pubaccu&cal=${this.formData.calcuMethod}&cityid=${this.$store.state.location.cityId}&cityname=${this.$store.state.location.cityName}&hideBroker=${this.$route.query?.hideBroker}`,
            );
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("err--->", err);
        });
    },
    linkLocation() {
      this.$router.push("/location");
    },
    handleLocation() {
      // 点击选择城市前的问号
      this.$store.commit("showLocationModal", true);
    },
    onMethodComplete() {
      this.formData.calcuMethod = this.$refs.methodRef.getValues()[0].text;
      this.showMehodsPicker = false;
    },
    onLoanTermComplete(value) {
      this.formData.loanTerm = value;

      if (parseInt(this.formData.loanTerm) > 5) {
        this.formData.rate = this.fund_rate_5[0].text;
      } else {
        this.formData.rate = this.fund_rate[0].text;
      }
      // 清空自定义填写项
      this.formData.customTerm = "";
      this.showLoanTermPicker = false;
    },
    checkTotal(value, from) {
      if (Number(value)) {
        const dicStr = String(value).split(".")[1]
          ? String(value).split(".")[1]
          : "00";
        if (Number(value) > this.firstMaxFundLoan) {
          this.formData.total = this.firstMaxFundLoan;
          this.$toast(`当前公积金上限为${this.firstMaxFundLoan}万,请重新输入`);
        } else if (dicStr?.length > 2) {
          this.$toast("最多支持两位小数");
          this.formData.total =
            String(value).split(".")[0] + "." + dicStr.substr(0, 2);
        }
      } else {
        if (from !== "house") {
          this.$toast("请输入大于0的数字");
        }

        this.formData.total = 0;
      }
      this.totalKeyboardShow = false;
    },
    // totalInput(value) {
    //   if (
    //     this.formData.calcuMethod === "按贷款总额" &&
    //     Number(value) > this.firstMaxFundLoan
    //   ) {
    //     this.pubaccuModalShow = true;
    //   }

    //   if (
    //     this.formData.calcuMethod === "按房屋总价" &&
    //     Number(this.formData.houseTotal)
    //   ) {
    //     // 判断当前为首套还是二套
    //     let currentMax = 0;
    //     if (this.formData.isFirst === "1") {
    //       if (Number(value) > this.firstMaxFundLoan) {
    //         currentMax = this.firstMaxFundLoan;
    //       } else {
    //         return;
    //       }
    //     } else if (this.formData.isFirst === "2") {
    //       if (Number(value) > this.secondMaxFundLoan) {
    //         currentMax = this.secondMaxFundLoan;
    //       } else {
    //         return;
    //       }
    //     }
    //     this.formData.total = currentMax;
    //     this.$toast(`目前北京的公积金金额上限为${currentMax}万`);
    //   }
    // },
    handleCustomTerm() {
      // 自定义贷款年限
      const LOANTERM = parseInt(
        this.loanTermList[this.loanTermList.length - 1],
      );

      console.log(this.formData.customTerm);
      if (
        this.formData.customTerm == "" ||
        this.formData.customTerm < 0 ||
        Number(this.formData.customTerm) > 30
      ) {
        this.$toast("请输入1-30年！");
      } else {
        this.showLoanTermPicker = false;
        this.formData.loanTerm = `${this.formData.customTerm}年`;
      }
      // if (this.formData.customTerm <= LOANTERM) {
      //   this.showLoanTermPicker = false;
      //   this.formData.loanTerm = `${this.formData.customTerm}年`;
      // } else {
      //   // 贷款年限大于30年小于等于60年，弹出提示框
      //   if (this.formData.customTerm > LOANTERM && this.formData.customTerm <= 60) {
      //     this.customModalShow = true;
      //   } else {
      //     this.$toast("自定义最大输入年限为60年，请重新输入！");
      //   }
      // }
    },
    modalConfirm() {
      // TODO 模态框确定
      if (parseInt(this.formData.loanTerm) > 5) {
        this.formData.rate = this.fund_rate_5[0].text;
      } else {
        this.formData.rate = this.fund_rate[0].text;
      }
      this.customModalShow = false;
      this.showLoanTermPicker = false;
      this.formData.loanTerm = `${this.formData.customTerm}年`;
    },
    modalCancel() {
      // TODO 模态框取消
      this.formData.customTerm = "";
    },
    accModalConfirm() {
      this.pubaccuModalShow = false;
    },
    accModalCancel() {
      this.formData.total = this.firstMaxFundLoan;
      this.pubaccuModalShow = false;
    },
    onRateComplete(item) {
      this.formData.rate = item.text;
      this.showRatePicker = false;
    },
    handleRateHelp() {
      this.$store.commit("showRateModal", true);
    },
    handleownPayment() {
      this.$store.commit("showHouseModal", true);
    },
    isFundRateCustom() {
      // 提交时校验自定义公积金利率（与完成时校验规则一致）
      const rate = this.formData.customRate;
      if (
        rate === "" ||
        !/^\d{1,3}(\.\d{1,4})?$/.test(rate) ||
        Number(rate) <= 0 ||
        Number(rate) > 100
      ) {
        this.$toast(
          "请将公积金利率修改为大于0，小于100的数字，支持小数点后四位",
        );
        return false;
      }
      return true;
    },
    handleCustomRate() {
      const valueStr = String(parseInt(this.formData.customRate));
      const dicStr = String(this.formData.customRate).split(".")[1];

      if (Number(this.formData.customRate) > 0) {
        if (dicStr?.length > 4) {
          this.$toast("最多输入四位小数");
          this.formData.customRate =
            String(this.formData.customRate).split(".")[0] +
            "." +
            dicStr.substring(0, 4);
          this.formData.rate = this.formData.customRate;
          this.showRatePicker = false;
          this.spanShow = true;
        } else if (valueStr.length > 3 || Number(valueStr) > 100) {
          this.$toast("输入数值过大，请重新输入");
          this.formData.customRate = "";
        } else {
          this.formData.rate = this.formData.customRate;
          this.showRatePicker = false;
          this.spanShow = true;
        }
      } else {
        this.formData.customRate = "";
        this.$toast("请输入大于0的数值");
      }
    },
    onDownPaymentComplete(value) {
      // 首付比例
      this.formData.downPayment = value;
      this.selectedPayment = true;
      // 计算首付
      this.formData.total = (
        (Number(this.formData.houseTotal) *
          (100 - parseInt(this.formData.downPayment))) /
        100
      ).toFixed(2);
      this.showDownPaymentPicker = false;
      this.checkTotal(this.formData.total);
    },
    handleCustomDownPayment() {
      // 自定义首付比例
      if (Number(this.formData.customDownPayment)) {
        if (
          Number(this.formData.customDownPayment) > 100 ||
          Number(this.formData.customDownPayment) < 10
        ) {
          this.$toast("请输入10-100之间的数字");
        } else {
          this.formData.customDownPayment = CustomDownPaymentNum(
            this.formData.customDownPayment,
          );
          this.formData.downPayment =
            CustomDownPaymentNum(this.formData.customDownPayment) + "%";
          //
          // 改变首付比例百分比的显示状态
          this.selectedPayment = true;
          // 计算首付
          this.formData.total = (
            (Number(this.formData.houseTotal) *
              (100 - parseInt(this.formData.downPayment))) /
            100
          ).toFixed(2);
          this.showDownPaymentPicker = false;
          this.checkTotal(this.formData.total);
        }
      } else {
        this.$toast("自定义首付比例不能为空！");
      }
    },
    onHouseTotal(value) {
      let defaultPercent = "";
      // 房屋总价的输入监听
      if (Number(value)) {
        const valueStr = String(parseInt(value));
        const dicStr = String(value).split(".")[1]
          ? String(value).split(".")[1]
          : "00";
        if (valueStr.length > 5) {
          this.$toast("输入值过大,请重新输入");
          this.formData.houseTotal = 0;
        } else {
          if (dicStr.length > 2) {
            this.$toast("最多支持两位小数");
            this.formData.houseTotal =
              String(value).split(".")[0] + "." + dicStr.substr(0, 2);
          }
        }

        defaultPercent = this.formData.downPayment;
        this.formData.total =
          (Number(this.formData.houseTotal) *
            (100 - parseInt(defaultPercent))) /
          100;
        this.formData.total = this.formData.total.toFixed(2);
      } else {
        if (this.blurBool) {
          this.$toast("请输入大于0的数值");
          this.formData.total = 0;
        } else {
          this.formData.total = 0;
        }
      }
    },
    calcuMethodChange(name) {
      if (name === "1") {
        this.formData.calcuMethod = "按房屋总价";
        this.formData.total = 0;
      } else if (name === "2") {
        this.formData.calcuMethod = "按贷款总额";
        this.formData.total = 0;
      }
    },
    isFirstChange(name) {
      // 用户选择首套或者二套时，请求后台的首付比例
      this.selectedPayment = false;
      if (name === "1") {
        this.formData.total = (
          (Number(this.formData.houseTotal) *
            (100 - parseInt(this.firstDefault))) /
          100
        ).toFixed(2);
        if (this.formData.total > this.firstMaxFundLoan) {
          this.formData.total = this.firstMaxFundLoan;
          this.$toast(`目前北京的公积金金额上限为${this.firstMaxFundLoan}万`);
        }
      } else if (name === "2") {
        this.formData.total = (
          (Number(this.formData.houseTotal) *
            (100 - parseInt(this.secondDefault))) /
          100
        ).toFixed(2);
        if (this.formData.total > this.secondMaxFundLoan) {
          this.formData.total = this.secondMaxFundLoan;
          this.$toast(`目前北京的公积金金额上限为${this.secondMaxFundLoan}万`);
        }
      }
    },
  },
  computed: {
    defaultCal() {
      if (this.$route.query.cal) {
        if (this.$route.query.cal === "按贷款总额") {
          return 1;
        } else if (this.$route.query.cal === "按房屋总价") {
          return 0;
        }
      } else {
        return 1;
      }
    },
    peopleInfo() {
      return this.$store.state.people;
    },
    firstDefault() {
      return this.$store.state.downPayment.firstDefault;
    },
    secondDefault() {
      return this.$store.state.downPayment.secondDefault;
    },
    ...mapState({
      fund_rate: (state) => {
        return state.fund_rate;
      },
      fund_rate_5: (state) => state.fund_rate_5,
    }),
    rateList() {
      return parseInt(this.formData.loanTerm) > 5
        ? this.fund_rate_5
        : this.fund_rate;
    },
    locationCity() {
      return this.$store.state.location.cityName;
    },
    firstMaxFundLoan() {
      return this.$store.state.firstMaxFundLoan;
    },
    secondMaxFundLoan() {
      return this.$store.state.secondMaxFundLoan;
    },
    loanTermList() {
      return this.$store.state.fundLoanTime;
    },
    downPayment() {
      return this.$store.state.first_downpayment_percent;
    },
  },
};
</script>

<style scoped>
.calcu-body {
  width: 714px;
  margin: 24px auto;
  border-radius: 16px;
  overflow: hidden;
}
.form-bg {
  background-color: #ffffff;
  padding-bottom: 25px;
}
.submit-btn {
  width: 638px;
  height: 96px;
  border-radius: 16px;
  line-height: 96px;
  background-color: #ffcc33;
  border: none;
  font-size: 28px;
  color: #333333;
  font-weight: 600;
}
.placeDiv {
  height: 250px;
  width: 100%;
}
.LprDiv {
  width: 666px;
  height: 72px;
  background: #fff9e5;
  border-radius: 12px;
  margin-top: 24px;
  margin-left: 24px;
  display: flex;
  align-items: center;
}
.LprText {
  display: block;
  margin-left: 32px;
  font-weight: 400;
  font-size: 28px;
  color: #222222;
  line-height: 40px;
}
.calcu-body /deep/ .van-cell {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 48px;
  height: 129px;
  box-sizing: border-box;
}

.calcu-body /deep/ .van-field__left-icon {
  position: absolute;
  top: 64px;
  left: 145px;
}
.calcu-body /deep/ .van-cell__title {
  color: #292b33;
  font-weight: bold;
  font-size: 32px;
}
.calcu-body /deep/ .van-field__body input,
.suffix {
  font-size: 28px;
  color: #333;
}
.input-container {
  width: 100%;
  display: flex;
  align-items: center;
}
.calcu-body .cursor {
  margin-left: 2px;
  height: 30px;
  width: 1px;
  opacity: 0;
  background: url("https://static-official.5i5j.com/offical/cdn/5e00398904093f6aca4be6a71ba652e1_1720433382281.gif")
    no-repeat center center;
}
.radioDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.calcu-body /deep/ .van-radio--horizontal {
  margin-right: 12px;
}
.radioDiv .active {
  width: 224px;
  height: 76px;
  background: url("https://static-official.5i5j.com/offical/cdn/8d4520f04014bfa00ce00e775c946ad8_1731550918382.png")
    no-repeat;
  background-size: 224px 76px;
  font-weight: 600;
  color: #222222;
}
.radioDiv .inactive {
  background: url("https://static-official.5i5j.com/offical/cdn/1180cf092a9e7e1b81b02ffdffefa6ff_1731563918501.png")
    no-repeat;
  background-size: 224px 76px;
  font-weight: 400;
  color: #666666;
}
.radio-text {
  width: 224px;
  height: 76px;
  font-size: 28px;
  text-align: center;
  line-height: 76px;
  font-style: normal;
}
.rateInput {
  position: relative;
}
.cal-method /deep/ .van-radio__label {
  margin-left: 0;
}
.van-cell:after {
  border-bottom: 0px !important;
}
.calcu-body /deep/ .van-cell:not(:first-child) .van-field__value {
  background-color: #f9f9f9 !important;
  width: 482px;
  height: 76px;
  border: 2px solid #eeeeee;
  border-radius: 12px;
  font-weight: 600;
  font-size: 28px;
  color: #222222;
  line-height: 76px;
  padding-left: 32px;
  padding-right: 32px;
}

.calcu-body /deep/ .van-field__label {
  height: 76px;
  width: 144px;
  font-weight: 500;
  font-size: 28px;
  color: #222222;
  line-height: 76px;
  margin-right: 58px;
}
.calcu-body /deep/ .van-radio-group .van-radio:last-child {
  margin-right: 0;
}
.calcu-body /deep/ .van-radio__icon .van-icon {
  display: none;
}
.popup-title {
  width: 670px;
  height: 112px;
  border-bottom: 2px solid #eeeeee;
  line-height: 112px;
  font-size: 32px;
  color: #333;
  margin: 0 auto;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.popup-title .complete {
  color: #ffcc33;
}
.custom-term {
  height: 112px;
  width: 670px;
  margin: 0 auto;
  border-top: 2px solid #eeeeee;
}
.customer-btn {
  color: #333;
  border: none;
  outline: none;
}
.custom-dialog-content {
  text-align: center;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 25px 48px 25px;
  padding-top: 80px;
  width: 568px;
  height: 218px;
  font-size: 30px;
  font-weight: 500;
  color: #333333;
  line-height: 45px;
  letter-spacing: 1px;
}
.down-payment-per {
  display: inline-block;
}
.margin-b-244 {
  margin-bottom: 488px;
}
</style>
